import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery-property',
  templateUrl: './gallery-property.component.html',
  styleUrls: ['./gallery-property.component.css']
})
export class GalleryPropertyComponent implements OnInit {
  disabledbutton : boolean = false;  
  pagitionfirst : boolean = false;
  pagitionsecond : boolean = false;
  paginationthird : boolean = false;
  pagitionfour : boolean = false;

  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
    this.getPaginationfirst();
  }

  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }
  
  
  EnableActive(pageNo)
  { 
    if(pageNo==1){
      this.pagitionfirst = true;
      this.pagitionsecond = false;
      this.paginationthird = false;
    }
    else if(pageNo==2){
      this.pagitionsecond = true;
      this.pagitionfirst = false;
      this.paginationthird = false;          
    }
    else if(pageNo==3){
      this.pagitionfirst = false;
      this.paginationthird = true;
      this.pagitionsecond = false; 
    }
    else if(pageNo==4)
    {
      if(this.pagitionfirst == true){
        this.pagitionfirst = false;
        this.paginationthird = false;
        this.pagitionsecond = true;

        document.getElementById("Page1").classList.remove('active');
        document.getElementById("Page3").classList.remove('active');
        document.getElementById("Page2").classList.add('active'); 
      }
      else if(this.pagitionsecond == true){
        this.pagitionfirst = false;
        this.paginationthird = true;
        this.pagitionsecond = false;
        document.getElementById("Page1").classList.remove('active');
        document.getElementById("Page2").classList.remove('active');
        document.getElementById("Page3").classList.add('active');
      }
      else{
        this.disabledbutton= true;
      }
    }
    document.getElementById("Page1").classList.remove('active');
    document.getElementById("Page2").classList.remove('active');
    document.getElementById("Page3").classList.remove('active');

    document.getElementById("Page"+pageNo).classList.add('active'); 
  }

  getPaginationfirst(){
    this.pagitionsecond = false;
    this.paginationthird = false;
    this.pagitionfirst = true;
    this.pagitionfour = false;
    document.getElementById("Page1").classList.add('active'); 
    document.getElementById("Page2").classList.remove('active');    
    document.getElementById("Page3").classList.remove('active');
    document.getElementById("Page4").classList.remove('active'); 
  }
  getPaginationsecond(){ 
    this.pagitionfirst = false;
    this.paginationthird = false;
    this.pagitionsecond = true;   
    this.pagitionfour = false; 
    document.getElementById("Page1").classList.remove('active');
    document.getElementById("Page2").classList.add('active');     
    document.getElementById("Page3").classList.remove('active');
    document.getElementById("Page4").classList.remove('active'); 
  }
  getPaginationthird(){ 
    this.pagitionfirst = false;
    this.paginationthird = true;
    this.pagitionsecond = false;
    this.pagitionfour = false;
    document.getElementById("Page1").classList.remove('active');       
    document.getElementById("Page2").classList.remove('active');
    document.getElementById("Page3").classList.add('active');  
    document.getElementById("Page4").classList.remove('active'); 
  }
  getPaginationfour(){ 
    this.pagitionfirst = false;
    this.paginationthird = false;
    this.pagitionsecond = false;
    this.pagitionfour = true;
    document.getElementById("Page1").classList.remove('active');       
    document.getElementById("Page2").classList.remove('active');
    document.getElementById("Page3").classList.remove('active');  
    document.getElementById("Page4").classList.add('active');  
  }
  

  getPaginationnext(){
    if(this.pagitionfirst == true){
      this.getPaginationsecond();
    }
    else if(this.pagitionsecond == true){
      this.getPaginationthird();
    }
    else if(this.paginationthird == true){
      this.getPaginationfour();
    }
    else{
      this.disabledbutton= true;
    }
  }
  getPaginationPrevious(){
  
    if(this.pagitionfour == true){
      this.getPaginationthird();
    }
    else if(this.paginationthird == true){
      this.getPaginationsecond();
    }
    else if(this.pagitionsecond == true){
      this.getPaginationfirst();
    }
    else{
      this.disabledbutton= true;
    }
  }


}
